module.exports = __webpack_public_path__ + "img/04.6bc4c70c.svg";